import { gql } from 'graphql-request';
import useSWRMutation from 'swr/mutation';
import { BasketFragment } from '@graphql/fragments';
import { basketRequest, BasketRequestProps } from '@hooks/basket/_utils';
import { formatBasket, useBasketMutation } from '@hooks/basket/useBasket';
import { useCustomerIdToken } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

export const validateGiftCardVIPAccessMutation = gql`
  ${BasketFragment}
  mutation ValidateGiftCardVIPAccess($giftCardCode: String!) {
    validateGiftCardVIPAccess(giftCardCode: $giftCardCode) {
      ...Basket
    }
  }
`;

interface Key extends BasketRequestProps {
  locale: string;
}

const fetcher = async (key: Key, { arg: giftCardCode }: { arg: string }) => {
  const { validateGiftCardVIPAccess: basket } = await basketRequest({
    ...key,
    variables: {
      giftCardCode,
    },
  });
  return basket;
};

export const useValidateGiftCardVIPAccess = () => {
  const { locale, country } = useCurrentUrl();
  const idToken = useCustomerIdToken();
  const mutate = useBasketMutation();

  return useSWRMutation(
    {
      document: validateGiftCardVIPAccessMutation,
      locale,
      idToken,
      country,
    },
    fetcher,
    {
      onSuccess: async (basket) => {
        const formattedBasket = formatBasket(basket, locale);
        await mutate(formattedBasket, { revalidate: false });
      },
    },
  );
};
